// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"posts-module--wrapper--3jMRP","card":"posts-module--card--3bPhx","body":"posts-module--body--39exQ","emoji":"posts-module--emoji--xzvvJ"};